import { Component, effect, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthApiService } from '../../../services/apis/auth-api.service';
import { AuthService } from '../../../services/auth.service';
import { validateFormGroup, validateNonEmptyString } from '../../../utils/form';
import { Button } from '../../common/button/button';

@Component({
  selector: 'app-update-account-profile-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    Button,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  templateUrl: './update-account-profile-dialog.html',
  styleUrl: './update-account-profile-dialog.scss',
})
export class UpdateAccountProfileDialog implements OnInit {
  loading: boolean = false;
  formGroup: FormGroup;
  constructor(
    private dialogRef: MatDialogRef<UpdateAccountProfileDialog>,
    private authService: AuthService,
    private fb: FormBuilder,
    private authApi: AuthApiService
  ) {
    this.formGroup = this.fb.group({
      fname: ['', [Validators.required, validateNonEmptyString]],
      lname: ['', [Validators.required, validateNonEmptyString]],
      email: [
        { value: '', disabled: true },
        [Validators.required, Validators.email],
      ],
    });
    effect(() => {
      const profile = this.authService.profile();
      this.formGroup.patchValue({
        fname: profile?.fname ?? '',
        lname: profile?.lname ?? '',
        email: profile?.email ?? '',
      });
    });
  }
  ngOnInit(): void {
    this.authService.getProfile();
  }

  close(r: any = null) {
    this.dialogRef.close();
  }

  async save() {
    const values = validateFormGroup(this.formGroup);
    if (!values) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.authApi.updateProfile({
        fname: values.fname,
        lname: values.lname,
      });
      this.authService.profile.set(r);
      this.close();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
